<!--
 * @Description: 校验是否开通ETC
 * @Author: lijinpeng
 * @Date: 2022-03-17 13:38:00
 * @LastEditors: lijinpeng
-->
<template>
  <nf-confirm
    :handle-cancel-btn-click="handleCancelBtnTap"
    :handle-save-btn-click="handleGoOpen"
    :show.sync="show"
    cancle-btn-text="暂不开通"
    save-btn-text="去开通"
    scrollbar-h="100px"
    width="600px"
  >
    <div slot="content" class="font_16">
      {{
        `温馨提示：当前选择企业：${
          data && data.principalPartName ? data.principalPartName : ''
        }，该企业未成功开通ETC业务，请前往【企业列表】去开通！`
      }}
    </div>
  </nf-confirm>
</template>
<script>
export default {
  name: 'NfCheckOpenEtc',
  props: {
    show: {
      // 控制是否显示
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
    source: String,
    storeModelName: String,
  },
  methods: {
    handleGoOpen() {
      // 跳转到企业管理 - 企业详情 - 业务配置
      this.handleCancelBtnTap();
      this.$router.push(
        `/enterprise/enterpriseInfo/detail?businessId=${this.data.businessId}&source=${this.source}&tab=fourth`,
      );
    },
    handleCancelBtnTap() {
      this.$emit('update:show', false);
      this.$store.commit(`${this.storeModelName}/setLastCorp`);
      this.$store.dispatch(`${this.storeModelName}/getList`);
    },
  },
};
</script>
